export default __webpack_public_path__ + "static/img10-3bbfb81c13b87820ed5ee3783cd5d640.png";